import { useCallback, useSyncExternalStore } from "react";
import { coordinatorRegistry } from "./registry";
import type { FieldError } from "./types";

export interface RefusedField<TState> {
  error: FieldError;
  savedState: TState;
}

export function useRefusedField<TState>(entityId: string, field: string): RefusedField<TState> | undefined {
  const coordinator = useSyncExternalStore(
    coordinatorRegistry.subscribe,
    useCallback(() => coordinatorRegistry.get(entityId), [entityId]),
  );
  const subscribe = useCallback(
    (cb: () => void) => (coordinator ? coordinator.subscribe(cb) : () => { /* no coordinator to subscribe to */ }),
    [coordinator],
  );
  const error = useSyncExternalStore(
    subscribe,
    useCallback(() => coordinator?.getFieldError(field), [coordinator, field]),
  );
  const savedState = useSyncExternalStore(
    subscribe,
    useCallback(() => coordinator?.getServerState(), [coordinator]),
  );
  if (!error || savedState === undefined) return undefined;
  return { error, savedState: savedState as TState };
}
